var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHardwareActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5078 3.375H5.50781C4.47228 3.375 3.63281 4.21447 3.63281 5.25V15.25C3.63281 16.2855 4.47228 17.125 5.50781 17.125H15.5078C16.5433 17.125 17.3828 16.2855 17.3828 15.25V5.25C17.3828 4.21447 16.5433 3.375 15.5078 3.375Z",
    stroke: "#9C4900",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2578 5.875H6.75781C6.41263 5.875 6.13281 6.15482 6.13281 6.5V14C6.13281 14.3452 6.41263 14.625 6.75781 14.625H14.2578C14.603 14.625 14.8828 14.3452 14.8828 14V6.5C14.8828 6.15482 14.603 5.875 14.2578 5.875Z",
    stroke: "#9C4900",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5078 3.375V2.125M13.6328 3.375V2.125M7.38281 3.375V2.125M10.5078 18.375V17.125M13.6328 18.375V17.125M7.38281 18.375V17.125M17.3828 10.25H18.6328M17.3828 13.375H18.6328M17.3828 7.125H18.6328M2.38281 10.25H3.63281M2.38281 13.375H3.63281M2.38281 7.125H3.63281",
    stroke: "#9C4900",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardwareActive);
export default __webpack_public_path__ + "static/media/hardware_active.6a8036ffb060e4cb0f2f96d02a128f60.svg";
export { ForwardRef as ReactComponent };